import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  MessagePosition,
  MessageType,
  SnackBarService,
} from '@epicuro-next/ataraxia/snack-bar';
import { ContentApiService } from '@epicuro-next/data/content';
import { IUser, UsersApiService } from '@epicuro-next/data/users';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import {
  uploadAvatarImage,
  uploadAvatarImageFail,
  uploadAvatarImageSuccess,
} from '../actions';

@Injectable()
export class UserAvatarEffects {
  constructor(
    private actions$: Actions,
    private userService: UsersApiService,
    private contentService: ContentApiService,
    private snackBarService: SnackBarService,
  ) {}

  public uploadAvatarImage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uploadAvatarImage),
      switchMap(({ file }) => this.contentService.putPersonal(file)),
      map((images) => images[0]),
      switchMap((image) =>
        this.userService.postCurrent({ imageLink: image.cdnUrl } as IUser),
      ),
      map((user) => uploadAvatarImageSuccess({ url: user.imageLink })),
      catchError((error: HttpErrorResponse) =>
        of(uploadAvatarImageFail({ error: error.message })),
      ),
    ),
  );

  public uploadAvatarImageSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(uploadAvatarImageSuccess),
        tap(() => {
          this.snackBarService.show(
            $localize`:UserMenu@@uploadAvatarImageSuccess:Your avatar changed successfuly.`,
            MessagePosition.BOTTOM,
            MessageType.SUCCESS,
          );
        }),
      ),
    { dispatch: false },
  );

  public uploadAvatarImageFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(uploadAvatarImageFail),
        tap(() => {
          this.snackBarService.show(
            $localize`:UserMenu@@uploadAvatarImageFail:There was an error while changing your avatar. Please try again later.`,
            MessagePosition.BOTTOM,
            MessageType.DANGER,
          );
        }),
      ),
    { dispatch: false },
  );
}
